import { Component, inject, Input } from '@angular/core';
import { FeldBeschreibungService } from '../../../service/feldbeschreibung/feldbeschreibung.service';
import { Observable } from 'rxjs';
import { FeldBeschreibung } from '../../../domain/model/feldbeschreibung.model';
import { Feld } from '../../../domain/model/feld.enum';
import { TooltipPosition } from '@angular/material/tooltip';

@Component({
    selector: 'redispatch-erzeugungsanlage-form-prefix',
    templateUrl: './erzeugungsanlage-form-prefix.component.html',
    styleUrls: [
        './erzeugungsanlage-form-prefix.component.scss',
    ],
    standalone: false,
})
export class ErzeugungsanlageFormPrefixComponent {

    @Input()
    public feld: Feld;

    @Input()
    public tooltipPosition: TooltipPosition = 'left';

    @Input()
    public disabled = false;

    private feldBeschreibungService = inject(FeldBeschreibungService);

    public get feldBeschreibung(): Observable<FeldBeschreibung | null> {
        return this.feldBeschreibungService.getCachedFeldBeschreibung(this.feld);
    }

}
